import React, { useState, useMemo } from "react";
import config from "config/config.js";

// react component for creating dynamic tables
import ReactTable from "react-table";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import DatePicker from "react-datepicker";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import Search from "@material-ui/icons/Search";
import Visibility from "@material-ui/icons/Visibility";
import SweetAlert from "react-bootstrap-sweetalert";
import Close from "@material-ui/icons/Close";

import reviewList from "api/review/reviewList.js";
import deleteReview from "api/review/delete.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const styles = {
  ...style,
  right: {
    float: "right"
  },
  left: {
    float: "left"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const useStyles = makeStyles(styles);

function datePicker(start, end, filter, onChange) {
  return (
    <>
      <DatePicker
        style={{ float: "left", width: "50%" }}
        selected={start}
        onChange={date => {
          const fil = filter && filter.value ? filter.value : {};
          fil.start = date;
          onChange(fil);
        }}
        selectsStart
        dateFormat="MM/yyyy"
        showMonthYearPicker
        startDate={start}
        endDate={end}
      />
      <DatePicker
        selected={end}
        onChange={date => {
          const fil = filter && filter.value ? filter.value : {};
          fil.end = date;
          onChange(fil);
        }}
        selectsEnd
        dateFormat="MM/yyyy"
        showMonthYearPicker
        endDate={end}
        startDate={start}
        minDate={start}
      />
    </>
  );
}
function customSelect(value, menuType, classes, change) {
  return (
    <Select
      value={value}
      onChange={e => {
        change(e.target.value);
      }}
      MenuProps={{ className: classes.selectMenu }}
      classes={{ select: classes.select }}
      style={{ width: "100%" }}
    >
      {menuType.map(el => {
        return (
          <MenuItem
            key={el}
            classes={{
              root: classes.selectMenuItem,
              selected: classes.selectMenuItemSelectedMultiple
            }}
            value={el}
          >
            {el}
          </MenuItem>
        );
      })}
    </Select>
  );
}
let filterState = {};

export default function ReactTables(props) {
  const a = window.location.search;
  const [review, setCheckIn] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const rederData = useMemo(
    () =>
      review.map(prop => {
        console.log(prop);
        let total = 0;
        let menu = 0;
        let ambience = 0;
        let service = 0;
        prop.score.forEach(el => {
          if (el.name === "total") {
            total = el.score.toFixed(2);
          }
          if (el.name === "service") {
            service = el.score.toFixed(2);
          }

          if (el.name === "ambience") {
            ambience = el.score.toFixed(2);
          }

          if (el.name === "menu") {
            menu = el.score.toFixed(2);
          }
        });
        return {
          _id: prop._id,
          categoria: prop.category.id,
          nome: prop.restaurantId ? prop.restaurantId.name : "",
          status: prop.status,
          alias: prop.restaurantId ? prop.restaurantId.alias : "",
          username: prop.userId ? prop.userId.username : "",
          date: moment(prop.date).format("DD/MM/YYYY"),
          total,
          menu,
          ambience,
          service
        };
      }),
    [review]
  );

  const classes = useStyles();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Lista recensioni</h4>
          </CardHeader>
          <CardBody>
            <Button
              color="white"
              aria-label="edit"
              justIcon
              round
              style={{
                position: "absolute",
                zIndex: 999,
                right: "36px",
                top: "12px"
              }}
              onClick={() => {
                reviewList(filterState).then(a => {
                  setCheckIn(a.reviews);
                  return a.users;
                });
              }}
            >
              <Search
                className={classes.headerLinksSvg + " " + classes.searchIcon}
              />
            </Button>

            <ReactTable
              data={rederData}
              filterable
              onSortedChange={newSorted => {}}
              onFetchData={state => {
                // if (JSON.stringify(sort) !== JSON.stringify(state.sorted)) {
                //   return null;
                // }
                const arrayToObject = array =>
                  array.reduce((obj, item) => {
                    obj[item.id] = item.value;
                    return obj;
                  }, {});
                const filter = arrayToObject(state.filtered);
                filterState = filter;
                if (filterState && Object.keys(filterState).length === 0) {
                  reviewList(filter).then(a => {
                    setCheckIn(a.reviews);
                    return a.users;
                  });
                }
              }}
              columns={[
                {
                  Header: "Alias",
                  accessor: "alias",
                  Cell: function alias(row) {
                    return (
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://www.foodiestrip.com/it/ristorante/${row.original.alias}`}
                      >
                        {row.row.alias}
                      </a>
                    );
                  },
                  filterMethod: () => true
                },
                {
                  Header: "nome",
                  accessor: "nome",
                  filterMethod: () => true
                },

                {
                  Header: "date",
                  accessor: "date",
                  Filter: ({ filter, onChange }) => {
                    const start =
                      filter && filter.value && filter.value.start
                        ? filter.value.start
                        : new Date("2016-01-01");
                    const end =
                      filter && filter.value && filter.value.end
                        ? filter.value.end
                        : new Date();
                    return datePicker(start, end, filter, onChange);
                  },
                  filterMethod: () => true
                },
                {
                  Header: "totale",
                  accessor: "total",
                  filterable: false,
                  filterMethod: () => true
                },
                {
                  Header: "servizio",
                  accessor: "service",
                  filterable: false,
                  filterMethod: () => true
                },
                {
                  Header: "menu",
                  accessor: "menu",
                  filterable: false,
                  filterMethod: () => true
                },
                {
                  Header: "location",
                  accessor: "ambience",
                  filterable: false,
                  filterMethod: () => true
                },
                {
                  Header: "username",
                  accessor: "username",
                  filterMethod: () => true
                },
                {
                  Header: "categoria",
                  headerStyle: {
                    textAlign: "left"
                  },
                  accessor: "categoria",
                  Cell: function Cat({ row }) {
                    return (
                      <>
                        <div style={{ margin: "10px", float: "left" }}>
                          {row.categoria}
                        </div>
                        <Visibility
                          style={{ margin: "10px" }}
                          onClick={() => {
                            window.open(
                              `${config.baseUrl}/admin/reviewAnalytics?id=${review[row._index]._id}`
                            );
                          }}
                          className={
                            classes.headerLinksSvg + " " + classes.searchIcon
                          }
                        />
                        <Button
                          round
                          justIcon
                          simple
                          className={classes.right}
                          color="danger"
                          onClick={() => {
                            props.updateAlert({
                              title:
                                "Sicuro di voler cancellare la recensione?",
                              confirmBtnText: "Cancella recensione",
                              showCancel: true,
                              confirm: () => {
                                deleteReview(row._original._id).then(
                                  response => {
                                    if (response && response.message) {
                                      props.updateAlert({
                                        title: "successo",
                                        success: true
                                      });

                                      const user = [...review];
                                      user.splice(row._index, 1);
                                      setCheckIn(user);
                                    }
                                  }
                                );
                              }
                            });
                          }}
                        >
                          <Close />
                        </Button>
                      </>
                    );
                  },
                  filterMethod: () => true
                }
              ]}
              defaultPageSize={25}
              showPaginationTop={false}
              showPaginationBottom
              className="-striped -highlight"
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
